<template>
  <div class="container d-flex align-items-center flex-column mt-1">
    <div class="maincontent-bg d-flex flex-column">
      <div class="container text-left mt-2 mb-2 text-playgame">
        ติดต่อเรา
      </div>
      <div class="container text-playgame text-left mt-3 mb-2">
        ยินดีรับฟังทุกปัญหาและทุกความคิดเห็น
      </div>
      <div class="container">
        <div class="d-flex flex-column">
          <div class="menu-input">
            <div class="user-input-header col-md-2 col-12 text-left">
              ชื่อ:
            </div>
            <div class="col-md-6 col-12 overflow-hidden text-left">
              <input
                data-aos="fade-left"
                data-aos-duration="500"
                data-aos-delay="100"
                type="text"
                class="user-input"
                placeholder="ชื่อ"
                v-model="userDetail.name"
              />
            </div>
          </div>
          <div class="menu-input">
            <div class="user-input-header col-md-2 col-12 text-left">
              Email:
            </div>
            <div class="col-md-6 col-12 overflow-hidden text-left">
              <input
                data-aos="fade-left"
                data-aos-duration="500"
                data-aos-delay="200"
                type="text"
                class="user-input"
                placeholder="Email"
                v-model="userDetail.email"
              />
            </div>
          </div>
          <div class="menu-input">
            <div class="user-input-header col-md-2 col-12 text-left">
              เบอร์โทรศัพท์:
            </div>
            <div class="col-md-6 col-12 overflow-hidden text-left">
              <input
                data-aos="fade-left"
                data-aos-duration="500"
                data-aos-delay="300"
                type="text"
                class="user-input"
                placeholder="เบอร์โทรศัพท์"
                v-model="userDetail.tel"
              />
            </div>
          </div>
          <div class="menu-input">
            <div class="user-input-header col-md-2 col-12 text-left">
              ข้อความ:
            </div>
            <div class="col-md-6 col-12 overflow-hidden text-left">
              <input
                data-aos="fade-left"
                data-aos-duration="500"
                data-aos-delay="400"
                type="text"
                class="user-input"
                placeholder="ข้อความ"
                v-model="userDetail.message"
              />
            </div>
          </div>
          <div class="menu-input">
            <div class="user-input-header offset-md-2 text-left"></div>
            <div class="col-md-6 col-12 submit-btn-container">
              <input
                @click="submitMessage()"
                type="button"
                class="submit-btn"
                value="Submit"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="maincontent-bg-end"></div>
  </div>
</template>

<script>
export default {
  name: 'contactus',
  created() {},
  data() {
    return {
      userDetail: {
        name: '',
        email: '',
        tel: '',
        message: '',
      },
    };
  },
  methods: {
    submitMessage() {},
  },
};
</script>

<style scoped>
.contactus-container {
  position: relative;
}

.contactus-icon-container {
  padding-top: 2rem;
  border: 1px solid #68ff9a;
  border-radius: 10px;
  background: linear-gradient(to bottom, #32a876, #43de84);
  margin-top: -14%;
  cursor: pointer;
}
.contactus-icon-container:hover {
  background: linear-gradient(to bottom, #43de84, #32a876);
  color: #f7f7f7;
}

.contactus-icon-text {
  font-weight: bold;
}
.submit-btn-container {
  text-align: left;
}

.menu-input {
  display: flex;
  margin-top: 1rem;
  flex-wrap: wrap;
}

.user-input-header {
  color: #f7f7f7;
}

.user-input {
  width: 100%;
}

.submit-btn {
  padding: 5px 10px;
  font-size: 1vw;
  border-radius: 5px;
  border-color: transparent;
  background: linear-gradient(to bottom, #32a876, #43de84);
  cursor: pointer;
  background-color: #f7f7f7;
}

.submit-btn:hover {
  background: linear-gradient(to bottom, #43de84, #32a876);
}

@media only screen and (max-width: 576px) {
  .submit-btn {
    font-size: 4vw;
  }

  .submit-btn-container {
    text-align: right;
  }

  .contactus-icon-container {
    margin-top: -14%;
  }
}
</style>
